import { render, staticRenderFns } from "./ProductCP5.vue?vue&type=template&id=7524c45a&scoped=true&"
import script from "./ProductCP5.vue?vue&type=script&lang=js&"
export * from "./ProductCP5.vue?vue&type=script&lang=js&"
import style0 from "./ProductCP5.vue?vue&type=style&index=0&id=7524c45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524c45a",
  null
  
)

export default component.exports